import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';
const initialStateAccount = {
    DealerPayment: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getDealerPayment = createAsyncThunk(
    'dealerPayment/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDealerPayment', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data.accounts);
            return response.data.dealerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const createDealerPayment = createAsyncThunk(
    'dealerPayment/add',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log("data", data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createDealerPayment', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDealerPayment());
            // console.log("response.dealerPayment", response.data.dealerPayment);
            return response.data.dealerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteDealerPayment = createAsyncThunk(
    'dealerPayment/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteDealerPayment/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getDealerPaymentById = createAsyncThunk(
    'dealerPayment/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getDealerPaymentById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.dealerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateDealerPayment = createAsyncThunk(
    'dealerPayment/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("update data", data);
        try {
            const { id, ...rest } = data;
            const response = await axiosInstance.put(`${BASE_URL}/updateDealerPayment/${id}`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log("Update ID :", response.data);
            dispatch(getDealerPayment());
            return response.data.dealerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllDealersData = createAsyncThunk(
    'dealerPayment/getAllDealersData',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDealersData', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.dealersData;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const DealerPaymentSlice = createSlice({
    name: 'dealerPayment',
    initialState: initialStateAccount,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDealerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealer Payment...';
            })
            .addCase(getDealerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealer Payment fetched successfully';
                state.DealerPayment = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getDealerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealer Payment';
            })
            .addCase(createDealerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Adding dealer...';
            })
            .addCase(createDealerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.DealerPayment.push(action.payload);
                state.message = action.payload?.message || 'Dealer Payment added successfully';
            })
            .addCase(createDealerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Dealer Payment';
            })
            .addCase(deleteDealerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Dealer Payment...';
            })
            .addCase(deleteDealerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.users = state.DealerPayment.filter((user) => user._id !== action.payload);
                state.message = action.payload?.message || 'Dealer Payment deleted successfully';
            })
            .addCase(deleteDealerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Dealer Payment';
            })
            .addCase(updateDealerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Dealer Payment...';
            })
            .addCase(updateDealerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.DealerPayment)) {
                    state.DealerPayment = state.DealerPayment.map(d =>
                        d._id === action.payload?._id ? action.payload : d
                    );
                }
                state.message = 'Dealer Payment updated successfully';
            })
            .addCase(updateDealerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Dealer Payment';
            })
            .addCase(getAllDealersData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealers Data...';
            })
            .addCase(getAllDealersData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dealersData = Array.isArray(action.payload) ? action.payload : [];
                state.message = 'Dealers Data fetched successfully';
            })
            .addCase(getAllDealersData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealers Data';
            })
    }
});


export default DealerPaymentSlice.reducer;